import { AvField, AvForm } from 'availity-reactstrap-validation'
import { useEffect, useRef, useState } from 'react'
import Loader from 'react-loaders'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Button } from 'reactstrap'
import useMediaQuery from '../../../CustomHook/useMediaQuery'
import { cms, tidyName, validateForAv } from '../../../helper'
import { primary_color } from '../../../Helper/uiHelper'
import { setNotification } from '../../../Redux/Reducers/notificationHandling'
import { request } from '../../../Redux/Sagas/requests/api'
import CMSWidgetModal from '../../CMSWidget/cmsWidgetModal'
import CMSHeroBanner from '../../CMSWidget/HeroBanner/heroBanner'
import './heroBanner.scss'
import { useHistory } from 'react-router-dom'

const RenderFields = ({ data }) => {
  let type = data?.component_name
  if (data?.field_setting?.textarea) {
    type = 'textarea'
  }
  switch (type) {
    case 'input':
      return (
        <AvField
          className='py-4 px-3'
          name={data?.field_id}
          placeholder={cms(data.cms_key) || data?.field_id}
          validate={data.component_call_validation ? validateForAv(data.component_call_validation, data.field_id) : {}}
        />
      )
    case 'textarea':
      return <AvField type='textarea' name={data?.field_id} placeholder={data?.field_id} />
    default:
      return <AvField name={data?.field_id} />
  }
}
const HeroBanner = ({ data, searchData, setSearchData, clearSearchData, setClearSearchData, widget_uuid }) => {
  const isDesktop = useMediaQuery('(min-width:768px)')
  const dispatch = useDispatch()
  const formRef = useRef(null)
  const location = useLocation()
  const history = useHistory()
  const searchParams = new URLSearchParams(location.search)
  const hideHeroBanner = searchParams.get('hideHeroBanner')
  const redirectToContact = searchParams.get('contact')

  const editMode = useSelector((state) => state.CMS.editMode)

  const [modalPosition, setModalPosition] = useState()
  const sectionRef = useRef(null)

  useEffect(() => {
    if (redirectToContact) {
      sectionRef.current?.scrollIntoView()
    }
  }, [])

  const handleSectionClick = () => {
    if (!editMode) return
    if (sectionRef.current) {
      const rect = sectionRef.current.getBoundingClientRect()
      setModalPosition({
        top: rect.height + 100,
        left: 200, // Align left edge with parent element
        width: '80%',
      })
    }
  }

  const [isLoading, setIsLoading] = useState(false)

  let heading = data?.heading,
    sub_heading = data?.sub_heading,
    text = data?.text,
    button_text = data?.button_text,
    form,
    image = data?.bg_image,
    mobile_image

  if (Array.isArray(data)) {
    data?.map((item) => {
      switch (item?.component_name) {
        case 'heading':
          heading = item?.value
          return
        case 'sub_heading':
          sub_heading = item?.value
          return
        case 'text':
          text = item?.value
          return
        case 'button_text':
          button_text = item?.value
          return
        case 'form':
          form = item?.forms
          return
        case 'bg_image':
          image = item?.value
        case 'mobile_background':
          mobile_image = item?.value
          return
      }
    })
  }

  const handleSubmit = (e, values) => {
    const payload = { ...values }
    setIsLoading(true)
    let url = form?.[0]?.component_call_data_connection?.[0]?.url
    request(url, 'POST', payload)
      .then((res) => {
        setIsLoading(false)
        if (res?.status == 200 || res?.status == 202) {
          dispatch(setNotification({ type: 'success', message: 'Message sent successfully!' }))
        } else {
          dispatch(setNotification({ type: 'error', message: 'Something went wrong!' }))
        }

        formRef.current.reset() // Reset the form fields
      })
      .catch(() => {
        setIsLoading(false)
        dispatch(setNotification({ type: 'error', message: 'Message sending failed!' }))
        formRef.current.reset()
      })
  }
  const onCloseModal = () => {
    let element = sectionRef?.current
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' })
    }
    setModalPosition(null)
  }

  if (hideHeroBanner) return
  const headingData = Array.isArray(data) && data?.find((item) => item?.component_name === 'heading')
  let backgroundImage = image
  if (!isDesktop && mobile_image) {
    backgroundImage = mobile_image
  }

  const raiseTicketButton = Array.isArray(data) && data?.find((item) => item?.component_name === 'button_text')
  const widgetImage = Array.isArray(data) && data?.find((item) => item?.component_name === 'image')

  return (
    <div
      className={`locker-container d-flex ${
        headingData?.name !== 'still_have_question' && 'mb-4'
      } justify-content-center content-widget position-relative ${modalPosition && 'active-cms-edit'}`}
      ref={sectionRef}
      onClick={handleSectionClick}
      // style={{ background: '#F5FCFF' }}
      style={{
        backgroundImage: `url(${process.env.REACT_APP_STORAGE + backgroundImage})`,
        backgroundSize: 'cover !important',
        border: '1px solid #00000009',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}>
      <div
        style={{
          padding: isDesktop ? '3rem 2rem' : '1rem',
          marginBlock: '2rem',
          background: form?.length !== 0 || raiseTicketButton ? 'transparent' : 'rgb(255 255 255 / 60%)',
          width: 'fit-content',
          maxWidth: isDesktop ? '70%' : '',
          minWidth: isDesktop ? '50rem' : '',
          border: form?.length !== 0 || raiseTicketButton ? 'none' : '2px solid #00000009',
        }}>
        <div className='d-flex flex-column align-items-center'>
          {/* {data?.hero_search_icon ? (
            <img src={process.env.REACT_APP_PUBLIC_STORAGE + data?.hero_search_icon} width={70} height={70} className='mb-2' />
          ) : (
            <i className='fa-solid fa-school' style={{ fontSize: '3rem', color: primary_color }}></i>
          )} */}
          {/* <i className='fa-thin fa-school' style={{ fontSize: '3rem', color: primary_color }}></i> */}
          <div className='mt-3' style={isDesktop ? { width: '45rem' } : {}}>
            <div className='text-center mb-4' style={{ color: primary_color, fontWeight: '700' }} dangerouslySetInnerHTML={{ __html: heading }}></div>
            {text && (
              <div className='text-center' style={{ marginBottom: '50px' }} dangerouslySetInnerHTML={{ __html: text?.replaceAll('h4', 'p') }}></div>
            )}

            {sub_heading && <div className='text-muted body1 mx-4 text-center' dangerouslySetInnerHTML={{ __html: sub_heading }}></div>}
            {widgetImage?.value && (
              <div className='d-flex justify-content-center'>
                <img
                  src={process.env.REACT_APP_STORAGE + widgetImage?.value}
                  style={{ height: '300px', marginBottom: '3rem', marginTop: '2rem' }}></img>
              </div>
            )}

            {raiseTicketButton?.name?.includes('raise_ticket') && (
              <Button
                className='w-100 poppin d-flex align-items-center justify-content-center mt-4'
                style={{
                  color: 'white',
                  border: `2px solid ${primary_color}`,
                  // height: isDesktop ? 45 : 45,
                  backgroundColor: primary_color,
                  borderRadius: 30,
                  paddingTop: '0.8rem',
                  paddingBottom: '0.8rem',
                }}
                onClick={() => {
                  history.push('/raise-a-ticket-list')
                }}>
                <span style={{ fontSize: isDesktop ? '16px' : '15px', fontWeight: 600 }}>{raiseTicketButton?.value}</span>
              </Button>
            )}
            {form?.[0]?.component_call_fields?.length > 0 && (
              <div className='px-4 hero-form' style={{ marginTop: '6rem' }}>
                <AvForm onValidSubmit={handleSubmit} ref={formRef}>
                  {form?.[0]?.component_call_fields?.map((field, index) => {
                    return <RenderFields key={field?.id || field?.field_id || index} data={field} />
                  })}
                  <Button
                    className='w-100 poppin d-flex align-items-center justify-content-center mt-4'
                    style={{
                      color: 'white',
                      border: `2px solid ${primary_color}`,
                      // height: isDesktop ? 45 : 45,
                      backgroundColor: primary_color,
                      borderRadius: 30,
                      paddingTop: '0.8rem',
                      paddingBottom: '0.8rem',
                    }}>
                    <span style={{ fontSize: isDesktop ? '16px' : '15px', fontWeight: 600 }}>{button_text || 'Send'}</span>
                    {isLoading && <Loader type='line-scale' color='#FFF' style={{ transform: 'scale(0.3)' }} />}
                  </Button>
                </AvForm>
              </div>
            )}
          </div>
        </div>
      </div>
      {modalPosition && (
        <CMSWidgetModal sx={{ ...modalPosition }} toggleModal={() => onCloseModal()}>
          <CMSHeroBanner data={data} toggleModal={() => onCloseModal()} widget_uuid={widget_uuid} />
        </CMSWidgetModal>
      )}
    </div>
  )
}

export default HeroBanner
